import React from "react";
import Alert from "react-bootstrap/Alert";

export const SlaNotice = () => (
  <Alert variant="info">
    <h4>Support Terms Notice</h4>

    <p>
      Basic, Free Trial, and Standard support plans do not include weekend support. Customers
      on these plans can expect to hear back from the Support team, Monday-Friday during their local
      business hours, per the support plan terms (
      <a href="https://www.okta.com/legal/support-terms/" target="_blank" rel="noopener external">
        Basic Support
      </a>
      ,{" "}
      <a
        href="https://www.okta.com/legal/auth0-pss-self-service/"
        target="_blank"
        rel="noopener external"
      >
        Standard Support
      </a>
      ).
    </p>
  </Alert>
);
